import { Component, OnInit } from '@angular/core';

declare function init_plugin();

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {

  constructor() {
    init_plugin();
  }

  ngOnInit() {
  }

}
